import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {MatButtonModule} from '@angular/material/button';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {AuthService} from "../service/auth.service";
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {MatMenu, MatMenuItem, MatMenuModule, MatMenuTrigger} from "@angular/material/menu";
import {UserService} from "../service/user.service";
import {KycStatusService} from "../service/kyc.status.service";
import {filter} from 'rxjs/operators';
import {TransactionService} from "../service/transaction.service";
import {TransactionSearchCriteria} from "../model/transaction.search.criteria";
import {WalletTransactionType} from "../enums/wallet.transaction.type.enum";
import {WalletTransactionStatus} from "../enums/wallet.transaction.status.enum";
import {MatBadgeModule} from "@angular/material/badge";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TokenDetailsComponent} from "../dialog/token-details/token-details.component";
import {MatDialog} from "@angular/material/dialog";
import {PendingManualTransferComponent} from "../dialog/pending-manual-transfer/pending-manual-transfer.component";
import {WalletTransactionMethod} from "../enums/wallet.transaction.method.enum";
import {CartService} from "../service/cart.service";
import {GeneralConfigService} from "../service/general.config.service";

@Component({
  selector: 'app-menu-bar',
  imports: [
    FlexLayoutModule,
    MatButtonModule,
    NgIf,
    MatIconModule,
    MatToolbar,
    RouterLink,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatMenuModule,
    NgForOf,
    NgOptimizedImage,
    MatBadgeModule,
    MatTooltipModule
  ],
  templateUrl: './menu-bar.component.html',
  standalone: true,
  styleUrl: './menu-bar.component.scss'
})
export class MenuBarComponent implements OnInit {
  private menuPanelHovered: Map<MatMenuTrigger, boolean> = new Map();
  private closeTimers: Map<MatMenuTrigger, any> = new Map();
  @ViewChild('coinsMenuTrigger') coinsMenuTrigger!: MatMenuTrigger;
  @ViewChild('configMenuTrigger') configMenuTrigger!: MatMenuTrigger;
  @ViewChild('accountMenuTrigger') accountMenuTrigger!: MatMenuTrigger;
  @ViewChild('userDropdownMenuTrigger') userDropdownMenuTrigger!: MatMenuTrigger;
  @ViewChild('userProductsMenuTrigger') userProductsMenuTrigger!: MatMenuTrigger;
  @ViewChild('directSaleMenuTrigger') directSaleMenuTrigger!: MatMenuTrigger;
  walletData: any = {};
  userId: any = "";
  isMenuOpen = false;
  isUserMenuOpen: boolean = false;
  userMenuTrigger: any;
  isUserVerified: boolean = false;
  isUserViewer: boolean = false;
  isInvestmentManager: boolean = false;
  getRole: any = [];
  mobileNumber: string | null = '';
  email: string | null = '';
  userData: any = {};
  currentRoute: string = '';
  transactionCount: number | null = 0;
  pageSize = 10;
  pageIndex = 0;
  isInventoryManager: boolean = false;
  isMetalDesignManager: boolean = false;
  isDirectSaleLiveRatesManager: boolean = false;
  isSchemeTransferManager: boolean = false;
  isTransactionUser: boolean = false;
  cartCount: number = 0;
  isDirectSaleEnabled: boolean = false;
  isProductsInvestmentEnabled: boolean = true;
  schemeUser: boolean = false;
  isUserManagementMenuOpen: boolean = false;
  isCoinsMenuOpen: boolean = false;
  isConfigMenuOpen: boolean = false;
  isAccountMenuOpen: boolean = false;
  isUserProductsMenuOpen: boolean = false;
  hostName: string;

  mobileDropdowns: { [key: string]: boolean } = {
    users: false,
    coins: false,
    config: false,
    products: false,
    payments: false,
    agents: false,
    userProducts: false,
    directSale: false
  };
  ENV_ICONS: Record<string, string> = {
    'Local Environment': 'laptop',
    'DEVELOPMENT': 'construction',
    'PRODUCTION': 'public'
  };

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private kycStatus: KycStatusService,
    public authService: AuthService,
    private userService: UserService,
    private transactionService: TransactionService,
    private cartService: CartService,
    private generalConfigService: GeneralConfigService
  ) {
    this.hostName = window.location.host;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentRoute = event.url;
      this.loadUserDetails();
    });
    this.kycStatus.statusChanged$.subscribe(() => {
      this.checkUserStatus();
    });
    this.isUserViewer = this.authService.hasAuthority('USER_VIEWER');
    this.isInvestmentManager = this.authService.hasAuthority('INVESTMENT_MANAGER');
    this.isInventoryManager = this.authService.hasAuthority('INVENTORY_MANAGER');
    this.isMetalDesignManager = this.authService.hasAuthority('METAL_DESIGN_MANAGER');
    this.isDirectSaleLiveRatesManager = this.authService.hasAuthority('DIRECT_SALE_LIVE_RATES_MANAGER');
    this.isSchemeTransferManager = this.authService.hasAuthority('SCHEME_TRANSFER_MANAGER');
    this.isTransactionUser = this.authService.hasAuthority('TRANSACTION_USER');

    this.schemeUser = this.authService.hasAuthority('SCHEME_USER');
    this.transactionService.refreshCount$.subscribe(() => {
      this.getPendingTransactionCount();
    });
    this.getPendingTransactionCount();
      this.cartService.cartCount$.subscribe(count => {
        this.cartCount = count;
      });
  }
  getBackground(): string {
    let defaultBackground = 'linear-gradient(to right, #303e49 0%, #303e49 25%, #3f5060 50%, #303e49 75%, #303e49 100%)';
    if (!this.isLoggedIn() || !this.isInternalUser()) {
      return defaultBackground;
    }
    if (this.hostName.includes('localhost')) {
      return defaultBackground;
    } else if (this.hostName.includes('dev')) {
      return '#4c7981';
    } else {
      return '#816e4c';
    }
  }

  getEnvironmentLabel(): string {
    if (!this.isLoggedIn() || !this.isInternalUser() || this.hostName.includes('localhost')) {
      return 'Local Environment';
    }
    return this.hostName.includes('dev') ? 'DEVELOPMENT' : 'PRODUCTION';
  }

  getEnvironmentIcon(): string {
    const label = this.getEnvironmentLabel();
    return (this.ENV_ICONS)[label] || '';
  }
  toggleMobileDropdown(key: string) {
    this.mobileDropdowns[key] = !this.mobileDropdowns[key];
  }

  getTokens() {
    if (this.userId) {
      this.dialog.open(TokenDetailsComponent, {
        width: '500px',
        data: {userId: this.userId}
      });
    }
  }
  HIDDEN_SUBMENU_ROLES = [
    'MARKETING_MANAGER',
    'USER_MANAGER',
    'SCHEME_DISPATCH_MANAGER',
    'PLANT_MANAGER',
    'LEGAL_MANAGER',
    'DIRECT_SALE_MANAGER',
    'METAL_DESIGN_MANAGER'
  ];

  get shouldHideSubmenu(): boolean {
    if (!this.isLoggedIn()) {
      return true;
    }
    return this.HIDDEN_SUBMENU_ROLES.some(role => this.authService.hasRole(role));
  }

  handleShopClick() {
    if (this.shouldHideSubmenu) {
      this.goToNextPage('/shop');
    }
  }
  getPendingTransactionCount() {
    if (this.userId && this.canTransactionView()) {
      let criteria = {
        walletId: this.walletData.walletId ? this.walletData.walletId : null,
        type: WalletTransactionType.MANUAL_TRANSFER,
        status: WalletTransactionStatus.PENDING,
      };
      this.transactionService.getTransactionsCount(criteria as TransactionSearchCriteria).subscribe({
        next: (resp) => { this.transactionCount = resp.body; }
      });
      if (!this.isInternalUser()) {
        this.transactionService.searchTransactions(criteria as TransactionSearchCriteria).subscribe({
          next: (resp) => {
            if (resp.body) {
              resp.body.forEach(transaction => {
                if (!transaction.transactionReferences.length &&
                  transaction.method != WalletTransactionMethod.WITHDRAWAL &&
                  transaction.method != WalletTransactionMethod.DEPOSIT) {
                  let popupCount = Number(localStorage.getItem('pendingTxnPopUpCount')) || 0;
                  const redirectUrl = `/funds/${this.walletData.id}/transactions`;
                  const isAlreadyOnPage = this.router.url.split('?')[0] === redirectUrl;
                  if (popupCount < 3 && !isAlreadyOnPage) {
                    popupCount++;
                    localStorage.setItem('pendingTxnPopUpCount', popupCount.toString());
                    const dialogRef = this.dialog.open(PendingManualTransferComponent, {
                      width: '400px',
                      disableClose: true
                    });
                    dialogRef.afterClosed().subscribe(result => {
                      if (result === 'redirect') this.router.navigate([redirectUrl]);
                    });
                  }
                }
              });
            }
          }
        });
      }
    }
  }

  loadUserDetails() {
    this.mobileNumber = this.authService.getPhoneNumberFromToken();
    this.email = this.authService.getEmailFromToken();
    this.getRole = this.authService.getUserRoles();
    this.userId = this.authService.getUserIdFromToken();
    this.isUserViewer = this.authService.hasAuthority('USER_VIEWER');
    this.isInvestmentManager = this.authService.hasAuthority('INVESTMENT_MANAGER');
    this.isInventoryManager = this.authService.hasAuthority('INVENTORY_MANAGER');
    this.isMetalDesignManager = this.authService.hasAuthority('METAL_DESIGN_MANAGER');
    this.isDirectSaleLiveRatesManager = this.authService.hasAuthority('DIRECT_SALE_LIVE_RATES_MANAGER');
    this.isSchemeTransferManager = this.authService.hasAuthority('SCHEME_TRANSFER_MANAGER');
    this.schemeUser = this.authService.hasAuthority('SCHEME_USER');
    this.checkUserStatus();
    this.getUserWallet();
    this.getPendingTransactionCount();
  }

  getUserWallet() {
    if(this.isLoggedIn()){
      if (this.userId && !this.isInternalUser()) {
        this.userService.getWallet(this.userId).subscribe({
          next: (resp) => { this.walletData = resp.body || {}; },
          error: (err) => { console.error('Failed to load wallet data', err); }
        });
      }
    }
  }

  checkUserStatus() {
    if (this.userId && this.isUserViewer) {
      this.userService.getUserById(this.userId).subscribe(resp => {
        const body = resp.body;
        this.userData = body;
        if (body?.status) this.isUserVerified = body.status === 'VERIFIED';
      });
    }
  }

  goToWalletTransactions() {
    if (this.walletData?.id) this.router.navigate([`/funds/${this.walletData.id}/transactions`]);
    this.closeMenu();
  }

  goToNextPage(path: any) { this.router.navigate([path]); }
  isAgent() { return this.authService.hasAuthority('AGENT_USER'); }
  isSchemeUser(): boolean { return this.authService.hasAuthority('SCHEME_USER'); }
  isMetalAssetUser() { return this.authService.hasAuthority('METAL_ASSET_USER'); }
  isAccountManager() { return this.authService.hasAuthority('ACCOUNTS_MANAGER'); }
  isMetalAssetManager() { return this.authService.hasAuthority('METAL_ASSET_MANAGER'); }
  canUserView(): boolean { return this.authService.hasAuthority('USER_VIEWER'); }
  canTransactionView(): boolean { return this.authService.hasAuthority('TRANSACTION_USER'); }
  canDeliveryView(): boolean { return this.authService.hasAuthority('DELIVERY_USER'); }
  canMarketingUser(): boolean { return this.authService.hasAuthority('MARKETING_USER'); }
  isInternalUser(): boolean { return this.authService.isInternalUser(); }
  isSchemeEmiUser():boolean { return this.authService.hasAuthority('INSTALLMENT_PAYMENT'); }


  isLoggedIn(): boolean {
    let user = this.authService.getUser();
    this.userId = this.authService.getUserIdFromToken();
    return !!user;
  }

  logout() {
    this.authService.logout();
    localStorage.removeItem('pendingTxnPopUpCount');
    this.router.navigateByUrl("/login");
    this.isMenuOpen = false;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      this.isUserMenuOpen = false;
      this.userMenuTrigger?.closeMenu();
    }
    if (!this.isMenuOpen) {
      Object.keys(this.mobileDropdowns).forEach(k => this.mobileDropdowns[k] = false);
    }
  }

  toggleUserMenu(trigger: MatMenuTrigger) {
    if (!this.isUserMenuOpen) {
      this.isUserMenuOpen = true;
      this.isMenuOpen = false;
      trigger.openMenu();
    } else {
      this.isUserMenuOpen = false;
      trigger.closeMenu();
    }
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.isUserMenuOpen = false;
    this.userMenuTrigger?.closeMenu();
    Object.keys(this.mobileDropdowns).forEach(k => this.mobileDropdowns[k] = false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('nav') &&
      !target.closest('.menu-button') &&
      !target.closest('.mat-icon-button[aria-label="Example icon-button with a menu"]')) {
      this.closeMenu();
    }
  }

  ngOnInit(): void {
    this.userId = this.authService.getUserIdFromToken();
    this.checkUserStatus();
    this.generalConfigService.getGeneralConfig().subscribe({
      next: (resp) => {
        this.isDirectSaleEnabled = (resp.body?.directSale?.enabled ?? false)
          && (resp.body?.emergencyServiceAvailability?.directSaleEnabled ?? true);
        this.isProductsInvestmentEnabled = resp.body?.emergencyServiceAvailability?.productsInvestmentEnabled ?? true;
      }
    });

  }

  formatRole(role: string): string {
    return role.split('_').map(word => word.charAt(0) + word.slice(1).toUpperCase()).join(' ');
  }

  isActive(route: string): boolean {
    if (this.currentRoute === route) return true;
    return this.currentRoute.startsWith(route + '/');
  }

  onTriggerEnter(trigger: MatMenuTrigger): void {
    const allTriggers = [
      this.coinsMenuTrigger,
      this.configMenuTrigger,
      this.accountMenuTrigger,
      this.userDropdownMenuTrigger,
      this.userProductsMenuTrigger,
      this.directSaleMenuTrigger
    ];
    allTriggers.forEach(t => {
      if (t && t !== trigger && t.menuOpen) {
        t.closeMenu();
      }
    });

    this.cancelTriggerClose(trigger);
    trigger.openMenu();
  }

  onWrapperLeave(trigger: MatMenuTrigger): void {
    this.scheduleTriggerClose(trigger);
  }

  onMenuPanelEnter(trigger: MatMenuTrigger): void {
    this.menuPanelHovered.set(trigger, true);
    this.cancelTriggerClose(trigger);
  }

  onMenuPanelLeave(trigger: MatMenuTrigger): void {
    this.menuPanelHovered.set(trigger, false);
    this.scheduleTriggerClose(trigger);
  }

  private scheduleTriggerClose(trigger: MatMenuTrigger): void {
    this.cancelTriggerClose(trigger);
    const timer = setTimeout(() => {
      if (!this.menuPanelHovered.get(trigger)) {
        trigger.closeMenu();
      }
    }, 50);
    this.closeTimers.set(trigger, timer);
  }

  private cancelTriggerClose(trigger: MatMenuTrigger): void {
    const existing = this.closeTimers.get(trigger);
    if (existing) {
      clearTimeout(existing);
      this.closeTimers.delete(trigger);
    }
  }

}
